import script from "./CaribeCoolerView.vue?vue&type=script&setup=true&lang=js"
export * from "./CaribeCoolerView.vue?vue&type=script&setup=true&lang=js"

import "./CaribeCoolerView.vue?vue&type=style&index=0&id=62d49280&lang=css"

const __exports__ = script;

export default __exports__